import Swiper, {Autoplay, EffectFade, Pagination} from 'swiper';

class SliderSplit {
  constructor(element) {
    this.element = element;
    this.swiper = null;
    this.slider = this.element.querySelector('[data-element="slider"]');
    this.sliderAutoplay = this.slider.dataset.autoplay;
    this.navigation = this.element.querySelector('[data-element="navigation"]');
  }

  init() {
    this.swiperInit();
  }

  swiperInit() {
    let autoplayDelay = false;

    if (parseInt(this.sliderAutoplay) > 0) {
      autoplayDelay = {
        delay: parseInt(this.sliderAutoplay) * 1000,
      };
    }

    this.swiper = new Swiper(this.slider, {
      autoHeight: true,
      autoplay: autoplayDelay,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      grabCursor: true,
      modules: [Autoplay, EffectFade, Pagination],
      pagination: {
        bulletActiveClass: 'slider-split__nav-item-active',
        bulletClass: 'slider-split__nav-item',
        clickable: true,
        el: this.navigation,
        renderBullet: function(index, className) {
          const number = index + 1;
          return '<span class="' + className + '">' + number.toString().padStart(2, 0) + '</span>';
        },
      },
      speed: 1000,
    });
  }
}

const sliderSplit = {
  init() {
    const sliderSplitElements = document.querySelectorAll('[data-module="slider-split"]');

    if (sliderSplitElements && sliderSplitElements.length) {
      sliderSplitElements.forEach((element) => {
        const sliderSplitElement = new SliderSplit(element);
        sliderSplitElement.init();
      });
    }
  },
};

export default sliderSplit;
